import { forward, sample } from 'effector'
import {
  $activeDealer,
  $activeTabMobileInDL,
  $dealers,
  $dealersFilter,
  $error,
  $fetching,
  fetchDealersFx,
  getCitiesFromStorageFx,
  init,
  setActiveDealer,
  setActiveTabMobileInDL
} from 'features/dealer-locator/model/units'

/** Индикатор загрузки при завершении запроса ставим в false **/

$fetching.on(fetchDealersFx.finally, () => false)
$error.on(fetchDealersFx.failData, (_, data) => data.message)
$activeTabMobileInDL.on(setActiveTabMobileInDL, (number) => number)

forward({
  from: init,
  to: getCitiesFromStorageFx
})

sample({
  source: init,
  clock: getCitiesFromStorageFx.doneData,
  fn: (getCitiesUrl, cities) => ({ getCitiesUrl, cities }),
  target: fetchDealersFx
})

/** Принимаем данные о всех доступных дилерах **/
sample({
  source: $dealersFilter,
  clock: fetchDealersFx.doneData,
  fn: (dealersFilter, dealersData) => {
    if (dealersFilter.length) {
      dealersData = dealersData.filter((dealer) => dealersFilter.includes(dealer.id))
    }

    return dealersData.map((dealer) => {
      dealer.reserveText = dealer.reserveText || ''
      return dealer
    })
  },
  target: $dealers
})

sample({
  clock: setActiveTabMobileInDL,
  target: $activeTabMobileInDL
})

forward({
  from: setActiveDealer,
  to: $activeDealer
})
